export default "__VITE_ASSET__D6lT_QJ7__"